import {
  Box,
  chakra,
  shouldForwardProp,
  useColorModeValue
} from '@chakra-ui/react';
import { isValidMotionProp, motion, useWillChange } from 'framer-motion';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

import AnnouncementButton from '@/components/LayoutComponents/HeaderComponents/AnnouncementButton';
import LngButton from '@/components/LayoutComponents/HeaderComponents/LngButton';
import MusicToggleButton from '@/components/LayoutComponents/HeaderComponents/MusicToggleButton';
import ReloadButton from '@/components/LayoutComponents/HeaderComponents/ReloadButton';
import PrevButton from '@/components/Modal/PrevButton';

import CommonModal from '../../components/Common/CommonModal';
import { COMMON_WEB_PATH } from '../../constant';
import useCheckLogin from '../../hook/useCheckLogin';
import { usePreviousPagePath } from '../../hook/usePreviousPagePath';
import { resetInvalidAuth } from '../../redux/action/member/memberAction';
import SigninForm from './signinForm';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const Signin = () => {
  const { t } = useTranslation();
  const i18n_header = (key) => t(`header.${key}`);

  const navigate = useNavigate();
  const previousPage = usePreviousPagePath();

  const baseBg = useColorModeValue('light.100', 'dark.100');

  const dispatch = useDispatch();

  const willChange = useWillChange();

  const { isLogin } = useCheckLogin();

  useEffect(() => {
    dispatch(resetInvalidAuth());

    if (isLogin) {
      navigate('/');
    }
  }, []);

  return (
    <ChakraBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ willChange }}
      display="flex"
      flexDirection={`column`}
      justifyContent={`flex-start`}
      alignItems="center"
      zIndex="10000"
      py="10vh"
      px="10px"
      width={{
        base: '100%'
      }}
      height={{
        base: '100%'
      }}
      overflowY={`scroll`}
      position="fixed"
      top={`0px`}
      left={`0px`}
      className={`no-scrollbar backdrop-blur-md lg:backdrop-blur-none`}
    >
      <CommonModal bgNone title={i18n_header('signin')}>
        {/* 隱形XX */}
        <Box px="common-x" position={'relative'}>
          <Box
            position={'absolute'}
            top={{ base: '-8em', sm: '-10em' }}
            left={{ base: '-2em', sm: '-3em' }}
            display={'flex'}
            gap={'10px'}
          >
            <ReloadButton />
            <LngButton />
            <MusicToggleButton />
            <AnnouncementButton />
          </Box>
          <Box
            width="100%"
            px="common-x"
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            className="no-scrollbar"
          >
            <SigninForm />
          </Box>
        </Box>
      </CommonModal>
    </ChakraBox>
  );
};

export default Signin;
